import React, { useState, useEffect } from 'react';
import { fetchExcercises, fetchSingleExcercise } from '../../services/api';
import ExerciseList from '../../components/ExerciseList/ExerciseList';
import ExerciseDetail from '../../components/ExerciseDetail/ExerciseDetail';
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import './ExerciseMainPage.css';
const ExerciseMainPage=()=>{

    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const loadItems = async () => {
          setIsLoading(true);
          try {
            const response = await fetchExcercises();
            setItems(response.data);
            // Otomatis select item pertama jika ada
            if (response.data.length > 0) {
              handleSelectItem(response.data[0].id);
            }
          } catch (err) {
            setError('Failed to load items');
          } finally {
            setIsLoading(false);
          }
        };
    
        loadItems();
      }, []);
    
      // Handle ketika item dipilih dari list
      const handleSelectItem = async (itemId) => {
        setIsLoading(true);
        try {
          const response = await fetchSingleExcercise(itemId);
          console.log(response.data);
          setSelectedItem(response.data);
        } catch (err) {
          setError('Failed to load item details');
        } finally {
          setIsLoading(false);
        }
      };
    
      // Handle setelah item diupdate (refresh data)
      const handleItemUpdated = async (updatedItem) => {
        if (updatedItem) {
          // Update the selected item directly
          setSelectedItem(updatedItem);
          // Update the item in the sidebar list as well
          setItems(prevItems => 
            prevItems.map(item => 
              item.id === updatedItem.id ? updatedItem : item
            )
          );
        } else if (selectedItem) {
          // Fallback: refetch data if no updated item provided
          await handleSelectItem(selectedItem.id);
        }
      };

      // Handle setelah exercise baru dibuat (add to list)
      const handleExerciseCreated = async (newExercise) => {
        if (newExercise) {
          // Add new exercise to the list
          setItems(prevItems => [...prevItems, newExercise]);
          // Select the newly created exercise
          setSelectedItem(newExercise);
        }
      };

      // Handle setelah exercise dihapus (remove from list)
      const handleExerciseDeleted = async (deletedExerciseId) => {
        // Remove exercise from the list
        setItems(prevItems => prevItems.filter(item => item.id !== deletedExerciseId));
        
        // If the deleted exercise was selected, clear selection
        if (selectedItem && selectedItem.id === deletedExerciseId) {
          setSelectedItem(null);
        }
      };

    return (
          <div className="header-container">
               <TopNavigation/>
               <div className="split-view-container">
                    <div className="exercise-list-panel">
                        {error && <div className="error-message">{error}</div>}
                        {isLoading && !items.length ? (
                        <div>Loading items...</div>
                        ) : (
                        <ExerciseList 
                            items={items} 
                            selectedId={selectedItem?.id}
                            onSelectItem={handleSelectItem}
                            onExerciseCreated={handleExerciseCreated}
                            onExerciseDeleted={handleExerciseDeleted}
                        />
                        )}
                    </div>
                    <div className="exercise-detail-panel">
                        {selectedItem ? (
                        <>
                            <h2>Exercise Details</h2>
                            {isLoading ? (
                            <div>Loading details...</div>
                            ) : (
                            <ExerciseDetail 
                                item={selectedItem} 
                                onItemUpdated={handleItemUpdated}
                            />
                            )}
                        </>
                        ) : (
                        <div className="empty-state">Select an item to view details</div>
                        )}
                    </div>
                </div>
          </div>
      )
}

export default ExerciseMainPage;